export const accordion = () => {

    const accordionLinks = document.querySelectorAll('.accordion--title-link');

    if (accordionLinks.length) {

        accordionLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const parent = e.target.closest('.accordion-block');
                parent.classList.toggle('is-expanded');
            });
        });

    }

}